import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope';
import { faReply } from '@fortawesome/pro-light-svg-icons/faReply';
import { faShieldCheck } from '@fortawesome/pro-light-svg-icons/faShieldCheck';
import type { MessageDescriptor } from 'react-intl';
import { OUTREACH_RAMP } from 'fym-shared/src/music24/outreach/mailboxRamp';
import { TypedMemo } from '../../../common/types';
import { mailboxGuideMessages as messages } from './mailboxGuideMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the guide; each part uses its own slice of it */
import styles from './MailboxGuide.module.scss';
/* eslint-enable css-modules/no-unused-class */

const PROMISES: ReadonlyArray<{
  key: string;
  icon: IconDefinition;
  title: MessageDescriptor;
  body: MessageDescriptor;
}> = [
  { key: 'own', icon: faEnvelope, title: messages.trustOwnTitle, body: messages.trustOwnBody },
  { key: 'replies', icon: faReply, title: messages.trustRepliesTitle, body: messages.trustRepliesBody },
  { key: 'slow', icon: faShieldCheck, title: messages.trustSlowTitle, body: messages.trustSlowBody },
];

/** The three promises under the tiles (design outreach-v2 p1 `.trust`). It hides once a provider is found. */
const TrustStripComponent: React.FC = () => {
  const intl = useIntl();
  const firstCap = OUTREACH_RAMP[0]?.perDay ?? 0;
  return (
    <div className={styles.trust} data-testid="mailbox-trust">
      {PROMISES.map((item) => (
        <div key={item.key} className={styles.trustItem}>
          <FontAwesomeIcon icon={item.icon} className={styles.trustIcon} />
          <div>
            <b>{intl.formatMessage(item.title)}</b>
            <p>{intl.formatMessage(item.body, { count: firstCap })}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export const TrustStrip = TypedMemo(TrustStripComponent);
